<div class="manage__activity-container">
  <p class="app__template--linked--header mt-8">Activity</p>
  <mat-tab-group class="remove-border-bottom custom-tab-group" animationDuration="0ms">
    <mat-tab selectedIndex="1">
      <ng-template mat-tab-label>
        Comments <span class="count-badge">({{ commentsCount }})</span>
      </ng-template>
      <div class="comment__section">
        <div class="comment__header-section" [style.height]="notesForm.controls['addNote'].valid ? 'fit-content' : '53px'">
          <form [formGroup]="notesForm">
            <mat-form-field appearance="fill" style="max-width: 100%" class="mat-comment">
              <textarea
                matInput
                #myTextarea
                autosize
                maxlength="250"
                formControlName="addNote"
                placeholder="Add a comment"
                data-gramm_editor="false"
                style="resize: none; font-size: 14px; line-height: 15px !important"
              >
              </textarea>
            </mat-form-field>
            @if (notesForm.controls['addNote'].valid) {
            <div class="d-flex comment__header-section-btn">
              <button mat-button class="btn-cancel" (click)="closeDialog()">cancel</button>
              <button
                mat-button
                class="btn-add"
                (click)="createNote('', '', '')"
                [class.disable-button-continue]="!notesForm.controls['addNote'].valid"
              >
                Add
              </button>
            </div>
            }
          </form>
        </div>
        <div class="comment__body-section">
          @if (notesList.length) {
          <div class="comment__body-list">
            @for (note of notesList; track note; let i = $index) {
            <div
              class="comment__body-list-item"
              [style.border-radius]="i == 0 ? ' 6px 6px 0px 0px' : i == notesList.length - 1 ? ' 0px 0px 6px 6px' : '0px'"
            >
              <div style="width: calc(100% - 30px)">
                <div class="d-flex" style="text-align: center">
                  <ngx-avatars
                    size="28"
                    src="{{ note?.profile_image_url }}"
                    name="{{ note?.first_name + ' ' + note?.last_name | titlecase }}"
                    [round]="true"
                    initialsSize="2"
                  ></ngx-avatars>
                  &nbsp;&nbsp;
                  <p class="note-name">{{ note?.first_name + ' ' + note?.last_name | titlecase | truncateStrPipe : 30 }}</p>
                </div>
                <textarea
                  id="notes-input{{ i }}"
                  class="notes-input-text"
                  [(ngModel)]="note.notes"
                  (ngModelChange)="onNoteChange($event, i)"
                  [value]="note.notes"
                  autosize
                  data-gramm_editor="false"
                  [readonly]="!editNotesItem[i]"
                  maxlength="250"
                  [minRows]="1"
                  [ngClass]="{ 'active-note': editNotesItem[i] }"
                  style="margin-top: -2px; font-size: 14px; font-weight: 400; line-height: 21px; width: 48vw"
                >
                </textarea>
                @if (editNotesItem[i]) {
                <div class="d-flex comment__body-section-btn">
                  <button mat-button class="btn-cancel" (click)="clearNotes(i)">cancel</button>
                  <button mat-button class="btn-add" (click)="createNote('editnotes', note, i)" [class.disable-button-continue]="!editNotesItem[i]">
                    Update
                  </button>
                </div>
                }
                <div class="notes-created-at font-semibold">
                  <span class="notes-created-at-time text-[#487AF0] font-bold">{{note?.formattedDate.datePart}}</span>
                  <span> - </span>
                  <span class="notes-created-at-time">{{note?.formattedDate.timePart}}</span>
                </div>
              </div>
              <div style="z-index: 0 !important; bottom: '-30px'" class="popup__wrapper self-popup small-height-popup">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menuItem"
                  (click)="$event.stopPropagation()"
                  [disableRipple]="true"
                  class="menu-bottom-mobile"
                >
                  <span class="material-icons more_vert_icon">more_vert</span>
                </button>
                <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel mypop-up">
                  <button mat-menu-item class="pt-1 popup-menu-item" (click)="editNotes(note, i)">
                    <p class="menuitem-text"><span class="material-icons material-icons-round menuitem-icon">edit</span>Edit</p>
                  </button>
                  <button mat-menu-item class="popup-menu-item" (click)="deleteNote(note.id, i)">
                    <p class="menuitem-text" style="color: #ff0000; line-height: 30px">
                      <span class="material-icons material-icons-round menuitem-icon" style="color: #ff0000">delete</span>Delete
                    </p>
                  </button>
                </mat-menu>
              </div>
            </div>
            }
          </div>
          } @if ((!notesList || notesList.length == 0) && !showLoader) {
          <div class="comment__zerostate">
            <img src="../../../../../../assets/images/notes-zero-state.svg" />
            <p class="notes-zerostate-text">No comments</p>
          </div>
          } @if (showLoader) {
          <div>
            <div class="flex width-100per note-zero-state-container">
              <div class="ph-item width-100per" style="border: 0px">
                <div class="ph-col-12">
                  <div class="ph-row">
                    <div class="ph-col-4"></div>
                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-2"></div>
                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-2"></div>
                  </div>
                  <div class="ph-row">
                    <div class="ph-col-12"></div>
                  </div>
                </div>
                <div class="ph-col-12">
                  <div class="ph-row">
                    <div class="ph-col-4"></div>
                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-2"></div>
                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-2"></div>
                  </div>
                  <div class="ph-row">
                    <div class="ph-col-12"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </mat-tab>
    <mat-tab selectedIndex="2">
      <ng-template mat-tab-label>
        History <span class="count-badge">({{ historyCount }})</span>
      </ng-template>
      <div class="history__section">
        @if (activiyLogList.length) {
        <div class="history__body-list">
          @for (activiyItem of activiyLogList; track activiyItem; let i = $index) {
          <div
            class="history__body-list-item"
            [style.border-radius]="i == 0 ? ' 6px 6px 0px 0px' : i == activiyItem.length - 1 ? ' 0px 0px 6px 6px' : '0px'"
          >
            <div>
              <div class="d-flex">
                <ngx-avatars
                  size="28"
                  [src]="activiyItem?.profile_image_url"
                  name="{{ activiyItem?.first_name + ' ' + activiyItem?.last_name | titlecase }}"
                  [round]="true"
                  initialsSize="2"
                ></ngx-avatars>
                <div style="margin-left: 12px">
                  <div style="margin-bottom: 6px; font-size: 14px" [innerHTML]="activiyItem?.message"></div>
                </div>
              </div>
              <div class="pt-2 notes-created-at font-semibold">
                <span class="notes-created-at-time text-[#487AF0] font-bold">{{activiyItem?.formattedDate.datePart}}</span>
                <span> - </span>
                <span class="notes-created-at-time">{{activiyItem?.formattedDate.timePart}}</span>
              </div>
            </div>
          </div>
          }
        </div>
        } @if ((!activiyLogList || activiyLogList.length == 0) && !showHistoryLoader) {
        <div class="mt-4 history__zerostate">
          <img src="../../../../../../assets/images/notes-zero-state.svg" />
          <p class="notes-zerostate-text">No history yet</p>
        </div>
        } @if (showHistoryLoader) {
        <div>
          <div class="flex width-100per note-zero-state-container">
            <div class="ph-item width-100per" style="border: 0px">
              <div class="ph-col-12">
                <div class="ph-row">
                  <div class="ph-col-4"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-2"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-2"></div>
                </div>
                <div class="ph-row">
                  <div class="ph-col-12"></div>
                </div>
              </div>
              <div class="ph-col-12">
                <div class="ph-row">
                  <div class="ph-col-4"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-2"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-2"></div>
                </div>
                <div class="ph-row">
                  <div class="ph-col-12"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </mat-tab>
    @if (fId == 1 && !showLoader && emailInformation?.message_textAsHtml) {
    <mat-tab selectedIndex="3">
      <ng-template mat-tab-label>
        Email Information <span class="count-badge">({{ emailInformationCount }})</span>
      </ng-template>
      <div class="comment__section">
        <div class="comment__body-section">
          <div class="comment__body-list">
            <div class="comment__body-list-item rounded-[6px]">
              <div class="w-[calc(100%-30px)]">
                <div class="app__between--justified--content">
                  <div class="flex items-center">
                    <ngx-avatars
                      size="28"
                      src="{{ emailInformation?.profile_image_url }}"
                      name="{{ emailInformation?.from_name | titlecase }}"
                      [round]="true"
                      initialsSize="2"
                    ></ngx-avatars>
                    <span class="note-name text-sm ml-2">{{ emailInformation?.from_name | titlecase | truncateStrPipe : 30 }}</span>
                    <span class="text-[12px] text-[#898F9E] ml-2">{{ emailInformation?.from_email }}</span>
                  </div>
                  <div class="notes-created-at font-semibold max-h-[80px] overflow-y-auto">
                    <span class="notes-created-at-time text-[#487AF0] font-bold">{{ emailInformation?.formattedDate?.datePart }}</span>
                    <span> - </span>
                    <span class="notes-created-at-time font-semibold">{{ emailInformation?.formattedDate?.timePart }}</span>
                  </div>
                </div>
                <hr />
                <div class="flex flex-col gap-3">
                  @if(emailInformation?.message_subject){
                    <span class="text-sm text-[#898F9E] font-medium">{{ emailInformation.message_subject }}</span>
                  }
                  <span class="app__attributes-dialog-content-body-text" [innerHTML]="emailInformation?.message_textAsHtml"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    }
  </mat-tab-group>
</div>
